<template>
  <el-card :style="display_style[appType]" class="logindata">
    <div class="logintext">
      <h4> TP-LINK 实名认证中心 </h4>
    </div>
    <div class="formdata">
      <el-form ref="form" :model="form" :rules="rules" size="small">
        <el-form-item prop="accountName">
          <el-input v-model="form.accountName" clearable placeholder="TP-LINK ID" />
        </el-form-item>
        <el-form-item prop="accountPassword">
          <el-input v-model="form.accountPassword" clearable placeholder="请输入密码" show-password />
        </el-form-item>
        <el-form-item prop="kaptchaCode">
          <el-input v-model="form.kaptchaCode" auto-complete="off" placeholder="验证码" style="width: 60%"/>
          <div class="login-code">
            <img :src="codeUrl" @click="getCode" alt="获取验证码">
          </div>
        </el-form-item>
      </el-form>
    </div>
    <div class="tool">
      <el-checkbox class="remenber" v-model="form.rememberMe"> 记住密码 </el-checkbox>
      <span class="forgetpas" @click="handleReset"> 忘记密码？ </span>
    </div>
    <div class="butt">
      <el-button :loading="loading" type="primary" style="width:100%;" @click.native.prevent="handleSubmit">
        <span v-if="!loading"> 登 录 </span>
        <span v-else> 登 录 中... </span>
      </el-button>
    </div>
  </el-card>
</template>

<script>
import {validatePass, base64ImgtoFile, getAppType, getUUID, notify} from "@/utils/util";
import { getKaptchaImg } from "@/api/login";
import Config from "@/config";
import Cookies from "js-cookie";
import { encrypt, decrypt } from "@/utils/rsaEncrypt";

const LOGIN_OUTTIME = "当前登录状态已过期，请重新登录！"

export default {
  name: "LoginPage",
  props: {
    appType: {
      type: String,
      default: "CERTIFICATION_PC"
    }
  },
  data () {
    return {
      display_style: {CERTIFICATION_MOBILE: "width: 80%; min-width: 300px", CERTIFICATION_PC: "width: 30%"},
      form: {
        accountName: "",
        accountPassword: "",
        rememberMe: false,
        kaptchaCode: "",
        kaptchaId: "",
      },
      checked: false,
      loading: false,
      cookiePass: "",
      codeUrl: "",
      rules: {
        accountName: [{ required: true, message: "请输入用户名", trigger: "blur" }],
        accountPassword: [{ required: true, message: "请输入密码", trigger: "blur" }, {validator: validatePass, trigger: "blur"}],
        kaptchaCode: [{required: true, message: "请输入验证码", trigger: "blur"}]
      },
    }
  },
  watch: {
    appType: function () {
      console.log("appType", this.appType)
    }
  },
  methods: {
    resetForm() {
      this.$refs.form.resetFields();
    },
    handleReset () {
      this.$emit("reset")
    },
    handleSubmit () {
      this.loading = true
      this.$refs.form.validate(valid => {
        const submitData = {
          accountName: this.form.accountName,
          accountPassword: this.form.accountPassword,
          kaptchaCode: this.form.kaptchaCode,
          kaptchaId: this.form.kaptchaId,
          rememberMe: this.form.rememberMe,
          appType: getAppType(),
          terminalUUID: getUUID()
        }
        if (valid) {
          console.log(submitData)
          if (submitData.rememberMe) {
            Cookies.set("accountName", submitData.accountName, { expires: Config.passCookieExpires })
            Cookies.set("accountPassword", encrypt(submitData.accountPassword), { expires: Config.passCookieExpires })
            Cookies.set("rememberMe", submitData.rememberMe, { expires: Config.passCookieExpires })
          } else {
            Cookies.remove("accountName")
            Cookies.remove("accountPassword")
            Cookies.remove("rememberMe")
          }
          this.$emit('submit', submitData, response => {
            this.loading = false
            if (response) {
              this.resetForm()
            }
          })
        } else {
          this.loading = false
          notify(Config.notifyErr, Config.submitErr)
        }
      })
    },
    getCode() {
      const params = { kaptchaId: getUUID() }
      getKaptchaImg(params).then(response => {
        if (response.error_code === 0) {
          const imgFile = base64ImgtoFile(response.result.kaptchaBase64)
          const blob = new Blob([imgFile], { type: "image/png" })
          this.codeUrl = (window.URL || window.webkitURL).createObjectURL(blob)
          this.form.kaptchaId = response.result.kaptchaId
          console.log(this.codeUrl, this.form.kaptchaId)
        } else {
          notify(Config.notifyErr, Config.errorMsg[response.error_code])
        }
      }).catch((err) => {
        console.log(err)
        notify(Config.notifyErr, Config.serverErrorMsg)
      })
    },
    getCookie() {
      const accountName = Cookies.get("accountName")
      let accountPassword = Cookies.get("accountPassword")
      const rememberMe = Cookies.get("rememberMe")
      // 保存cookie里面的加密后的密码
      this.cookiePass = accountPassword === undefined ? "" : decrypt(accountPassword)
      accountPassword = accountPassword === undefined ? this.form.accountPassword : decrypt(accountPassword)
      this.form = {
        accountName: accountName === undefined ? this.form.accountName : accountName,
        accountPassword: accountPassword,
        rememberMe: rememberMe === undefined ? false : Boolean(rememberMe)
      }
      console.log("form", this.form)
    },
    point() {
      const point = Cookies.get("point") !== undefined
      if (point) {
        notify(Config.notifyErr, LOGIN_OUTTIME)
        Cookies.remove("point")
      }
    }
  },
  mounted () {
    // 获取验证码
    this.getCode()
    // 获取用户名密码等Cookie
    this.getCookie()
  }
}
</script>

<style scoped>
.logintext {
  text-align: center;
  font-size: 20px;
  font-weight: bolder;
  color: black;
}

.el-card {
  transform: translate(-50%);
  margin-left: 50%;
  margin-top: 10%;
}

.tool {
  display: flex;
  justify-content: space-between;
  color: black;
}

.butt {
  width: 100%;
  margin-top: 10px;
  text-align: center;
}

.remenber {
  color: black;
}

.forgetpas {
  cursor: pointer;
  color: #909399;
}

.login-code {
  width: 40%;
  display: inline-block;
  height: 38px;
  float: right;
}

img {
  cursor: pointer;
  vertical-align:middle
}
</style>